const en = {
  grannbox_onboarding: {
    login_header: "Login to ihopa",
    login_subheader: "After logging in to your account, you will be redirected to our payment page.",
    forgot_pass_header: "Forgot password",
    forgot_pass_subheader: "Add your ihopa email, and we will send you a reset password link.",
    create_account_header: "Create account",
    create_account_subheader: "After creating your free ihopa account, you will be redirected to our payment page.",
    login_continue: "Login & continue",
    back_to_login: "Back to login",
    new_to_ihopa: "New to ihopa? Create account",
    already_have_account: "Have an account? Login",
    why_phone: "We need it to send you sms:es",
    why_address: "To enable the right product selection",
    continue: "Continue",
    phone_number: "Phone number",
  },
  menu: {
    home: "Home",
    how_it_works: "How it works",
    why_co_own: "Why co-own",
    about_us: "About us",
    sign_up: "Sign up",
    login: "Login",
    logout: "Logout",
    dashboard: "My circles",
    account: "My account",
    messages: "Messages",
    notifications: "Notifications",
    my_circles: "My Circles",
    dont_have_account: "Don't have an account?",
    forgot_password: "Forgot your password?",
    register_here: "Register here",
    recover_password: "Recover Password",
    terms_of_use: "Terms of use",
    privacy_policy: "Privacy Policy",
    partners: "Our partners",
    ihopa_for_business: "Ihopa for your business",
    press: "Press",
  },
  why_co_own: {
    cta: "START CO-OWNING",
    our_partners: "Our partners",
  },
  sign_up: {
    title: "Sign up",
    read_and_accept: "I’ve read and accepted the",
    register: "Register",
    next_step: "Next step",
    login_here: "Login here",
    have_account: "Already have have an account?",
    placeholders: {
      email_address: "Email address",
      first_name: "First name",
      last_name: "Last name",
      password: "Password",
    },
  },
  login: {
    title: "Login",
    placeholders: {
      email_address: "Email address",
      password: "Password",
    },
  },
  cookie_conset: {
    message:
      "Ihopa.com uses cookies, which is a small text file that is stored on the device that you are browsing with, for the following purposes: to enable a better user experience, to decrease loading times, to customise content, to enable user identification, to gather statistical data and to learn how to improve the website. We use both our own cookies as well as third party cookies (such as google). We use both persistent and session cookies, where the latter does not persist after your session. By using our ihopa.com you consent to the use of cookies.",
    button: "Accept",
  },
  home: {
    hero: {
      how_it_works: "How it works",
      learn_more: "Learn more",
    },
    co_buy: {
      button_text: "Start co-owning",
    },
    prylpoolen: {
      button_text: "Go to Prylpoolen",
    },
    circle_collection: {
      heading: "Opened co-owning circles",
      subheading: "Join co-owning circles already created by other users.",
    },
    circle_suggestions: {
      heading: "Suggestions: create your own",
      subheading: "Unsure what to co-own? Check these suggestions hand-picked by our team.",
    },
    trustpilot_rating: "We are rated 4.8 out of 5",
    havent_found_heading: "Start co-owning now",
    havent_found_subheading: "We make it easy and secure",
    request_circle: {
      heading: "Request a new circle",
      sub_heading: "Tell us what you’re looking for and we’ll match you",
      button: "Request",
    },

    ready_to_co_own: {
      heading: "Ready to co-own?",
      sub_heading: "Save money and environment by sharing the ownership with friends and neighbours. Win-win-win.",
      button: "Start now",
      faq_button: "Read the FAQs",
    },
  },
  circle: {
    per_month: "Per month",
    circle_creator: "Circle creator",
    start_co_owning: "Request to join",
    commitment_info:
      "By requesting to join you are only sending your interest and are not committing to any purchase. Once admitted you can use the circle chat and test the tools.",
    per_person: "Per person",
    location: "Location",
    spot_left: "Spots left",
    ready_to_co_own: "Ready to co-own this?",
    co_owners: "Co-owners",
    lets_start: "Let's start!",
    in: " in ",
    white_monday_join: "Join",
  },
  circle_members: {
    heading: "Circle members",
    circle_creator: "Circle creator",
    circle_member1: "Joined ",
    circle_member2: " ago",
    make_admin: "Make admin",
    kick_user: "Kick user out",
    migrate_members: "Migrate members to this circle",
    copy_members: "Copy members",
    source_circle: "Source circle guid",
  },
  member_requests: {
    accept: "Accept",
    reject: "Reject",
    pending_request: "Pending requests",
  },
  new_circle: {
    create: "Create",
    heading: "Create your circle",
    subheading: "Invite your friends, share on social media",
    create_a_circle: "Create a circle",
    did_not_find: "Sorry, no open circles",
    did_not_find_description: "Currently, there are no suitable and open circles near you.",
    public_circle_switch: "Visible for all",
    pre_owned_switch: "Pre-owned product",
    agreement_switch: "Add agreement to circle",
    public_circle_title: "What does 'visible for all' mean ",
    pre_owned_title: "What is a pre-owned product",
    agreement_title: "What's an agreement?",
    agreement_explain:
      "If 2 or more people co-own something it's smart to have a co-owning agreement in place. Especially if it's a bigger item like a boat. ihopa is happy to help out to modify the agreement if you need that. ",
    public_circle_explain:
      "Visible for all means that as long as it's not completed, anyone can see it and request to join. That way you maximise the chances to find suitable co-owners. Don't worry - you can always reject join requests.",
    pre_owned_explain: "Something that is already owned by you alone or in a group",
    create_circle_button: "Create your Circle",
    edit_circle_button: "Update Circle",
    preview_agreement_button: "Preview Agreement",
    is_prylpoolen_switch: "Is Prylpoolen",
    is_prylpoolen_title: "Is prylpoolen title",
    is_prylpoolen_explain: "Is prylpoolen explain",
    booking_limitations_title: "Booking limitation",
    booking_limitations_explain:
      "Here you can set limitations to each members bookings. Max. number of bookings refers to how many single booking a member can do in advance. You can also limit maximum time of each booking.",
    unlimited: "Unlimited",
    labels: {
      add_product_image: "Add a product image",
      product_name: "Product name",
      product_category: "Product category",
      product_price: "Product Price",
      product_url: "Product URL",
      description: "Write something to make other users join",
      number_of_owners: "Number of co-owners",
      max_active_bookings: "Max active bookings",
      max_booking_duration: "Max booking duration",
      circle_status: "Circle status",
      door_id: "Door ID",
      door_indications: "Door indications",
      door_indications_heading: "Door indications heading",
      door_indications_paragraph_1: "Door indications paragraph 1",
      door_indications_paragraph_2: "Door indications paragraph 2",
      door_indications_image_url: "Door indications image url",
      rentable_switch: "Is rentable",
      rental_pricing_tier: "Rental pricing tier",
    },
    placeholders: {
      paste_image_url: "Or paste an image URL here (optional)",
      product_name_suggestion: "GoPro Camera",
      select_category: "Select a category",
      add_price: "Add a price",
      url_suggestion: "https://domain.com/product",
      description_placeholder: "Be creative 😃",
      door_id: "Door ID",
      door_indications: "Door indications",
      door_indications_heading: "Door indications heading",
      door_indications_paragraph_1: "Door indications paragraph 1",
      door_indications_paragraph_2: "Door indications paragraph 2",
      door_indications_image_url: "Door indications image url",
      rentable_switch: "Is rentable",
      rental_pricing_tier: "Rental pricing tier",
    },
  },
  new_expense: {
    placeholders: {
      expense: "Name your expense...",
      price: "SEK",
    },
  },
  new_usage_log: {
    placeholders: {
      description: "Describe usage",
      value: "Value",
      unit: "Unit",
    },
    options: {
      km: "km",
      hrs: "hours",
      min: "minutes",
    },
  },
  circle_admin: {
    members: "Members",
    per_person: "Per person",
    location: "Location",
    paragraph1: "The circle needs ",
    paragraph2: " more co-owner(s). Invite friends",
    share_button: "Copy url",
    share_button_facebook: "Share",
    sign_agreement_notification: "Please sign your agreement",
    wait_others_sign_agreement: "Now we wait others to sign agreement",
    wait_for_purchase: "Now we wait admin to purchase item.",
    admin_purchase_item: "Now you can purchase item.",
    purchase_button: "Item purchased",
    sign: "Sign",
    already_signed: "already signed the agreement. You need to sign it too!",
    copied_to_clipboard: "Circle url copied to clipboard",
    share_on_facebook: "Share this with your friends",
  },
  circle_status: {
    member_gathering: "Member Gathering",
    awaiting_purchase: "Awaiting Purchase",
    progress: "In progress",
    pending: "Pending",
    awaiting_commitment: "Awaiting Commitment",
    completed: "Completed",
  },
  public_profile: {
    profile: "`s profile",
    send_message: "Send Message",
    about: "About ",
    location: "Location",
    member_since: "Member since ",
    user_circles: "'s co-owning circles",
    not_in_circles: "isn't in a co-owning circle",
    create_circle_with_him: "Create one and share it with him/her.",
    create_circle: "Create a circle",
    sidebar_right_heading: "Co-owning circles",
  },
  user_details: {
    member_since: "Member since",
    save_profile: "Save profile",
    public_profile: "Public profile",
    labels: {
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      location: "Your location",
      description: "A little bit about you",
      change_password: "Change password",
      confirm_password: "Confirm password",
      mobile_phone: "Mobile phone",
    },
    placeholders: {
      first_name: "John",
      last_name: "Doe",
      email: "john.doe@domain.com",
      location: "Address",
      description: "Start typing...",
      change_password: "Leave blank for current one",
      confirm_password: "Leave blank for current one",
      mobile_phone: "Mobile phone +46...",
    },
  },
  user_activation_banner: {
    heading: "Please activate your account!",
    resend_activation_email: "Resend activation",
    paragraph1: "We sent you an activation link on your email ",
    paragraph2: " You haven't got it yet?",
  },
  collection_page: {
    owners_suggested: "Co-owners suggested",
    heading: "Suggestions: create your own co-owning circle",
    subheading: "Unsure what to co-own? Check these suggestions hand-picked by our own team.",
    opened_circles_heading: "Opened co-owning circles",
    opened_circles_subheading: "Join co-owning circles already created by other users.",
  },
  recover_password: {
    heading: "Recover password",
    button: "Recover password",
    email_placeholder: "Email",
  },
  reset_password: {
    change_password: "Change password",
    button: "Change password",
    password_placeholder: "Password",
    password_repeat_placeholder: "Repeat Password",
  },
  suggestion: {
    per_person: "Per person",
  },
  general_messages: {
    no_circles: "No circles",
    load_more: "Load More",
    send_request: "Send Request",
    find_match: "Let's find a match for you",
  },
  google_maps_modal: {
    title: "Circle location",
    save_location: "Save location",
  },
  profile_completeness: {
    heading: "Profile completeness: ",
    subheading: "Users with a complete profile have more chances to get accepted into co-owning circles.",
    add_avatar: "Add an avatar",
    add_address: "Add your address",
    about_you: "Add something about you",
  },
  booking: {
    select_period: "Select your desired booking period.",
    days_booked: " days booked",
    overlapping_interval: "Overlapping intervals",
    cancel_booking: "Cancel booking",
    user_booking: "User Booking",
    save_booking: "Save booking",
    start_date: "Start Date",
    end_date: "End Date",
    existing_bookings: "Existing Bookings",
    subscription: "Subscription",
  },
  expenses: {
    user: "User",
    spent: "Spent",
    ago: " ago",
    total_spent: " in total spent in so far.",
  },
  messaging: {
    title: "Messages",
    new_message_button: "New message",
    messages_inside_circles_label: "Messages inside circles",
    personal_messages_label: "Personal messages",
  },
  notifications: {
    title: "Notifications",
    no_notifications: "You're all up to date for now.",
    setup_circle: "Would you like to setup a new co-owning circle?",
    create_circle: "Create a circle",
  },
  request_circle: {
    labels: {
      description: "Circle description",
    },
    placeholders: {
      description: "Describe what you need.",
    },
  },
  my_circles: {
    heading: "My circles",
    create_circle: "Create a circle",
    circles_near_you: "Circles near you",
    you_have_no_circles: "You have no co-owning circles",
    setup_new_circle: "Let's set-up one right now.",
  },
  errors: {
    commitment: {
      fetch: "Cannot fetch the circle commitments",
      sign: "Commitment sign failed, please try again.",
    },
    login: {
      invalid_email: "Invalid email address",
      password_required: "Password is required",
    },
    register: {
      invalid_email: "Invalid email address",
      invalid_first_name: "First name required",
      invalid_last_name: "Last name required",
      password_to_short: "Password is to short (min 6 character)",
      accept_terms: "Please read terms and accept them",
      invalid_phone_number: "Invalid phone number",
    },
    circle_collection: {
      fetch: "Cannot fetch the circle collections",
      unhandled: "Unhandled circle collection error",
    },
    circle_suggestions: {
      fetch: "Cannot fetch circle suggestions",
      unhandled: "Unhandled circle suggestions error",
    },
    iam: {
      login: "Invalid user name or password",
      register: "Could not create user, please try again later",
      register_duplicated: "Registration error, email already exists",
      session_expired: "Session expired, please login again",
    },
    users: {
      fetch: "Cannot fetch user profile",
      update: "Cannot update user profile",
      error_on_reset_password: "Error on reset password",
      resend_activation_email: "Error on resend activation email",
    },
    update_user_details: {
      description: "Please write some words about you!",
      passwords_not_matching: "Passwords not matching",
      error_on_activate_account: "Error on validating your email",
    },
    new_circle: {
      valid_url: "Please add a valid product url",
      product_name: "Please add a product name",
      description: "Please describe product",
      add_product_price: "Please add a product price",
      add_product_image: "Please add a product image",
      add_location: "Please add circle location",
      image_to_big: "Please choose a smaller image than 3 Mb",
    },
    save_circle: {
      error_on_save: "Error on saving circle details, please try again.",
    },
    member_requests: {
      fetch: "Error on fetching circle requests",
      update: "Error on update circle requests",
      already_member: "You are already a member",
      already_send_join_request: "You already send a join request to this circle",
      join_request: "Error on join request, please try again",
    },
    my_circles: {
      fetch: "Error on fetching your circles",
      mark: "Error on marking product as bought",
      migrate: "Error on migrating users",
    },
    bookings: {
      fetch: "Error on fetching your booking",
      add_booking: "Error on register your booking, please try again",
      MaxBookingDurationExceeded: "You have exceeded your maximum duration for a booking allowed in this circle",
      MaxActiveBookingsExceeded: "You have exceeded your maximum number of allowed active bookings",
    },
    expenses: {
      fetch: "Error on fetching your expenses",
      register_expense: "Error on adding new expense",
      add_booking: "Error on register your expense, please try again",
      add_price: "Please add a price. ",
      add_expense: "Please add expense details.",
    },
    usage_logs: {
      fetch: "Error on fetching your usage logs",
      register_usage: "Error on adding new usage log entry",
      add_usage_description: "Please add usage details.",
      add_value: "Please add a value",
      add_unit: "Please add a unit",
    },
    request_circle: {
      description: "Please describe what you need",
    },
    prypool_products: {
      fetch: "Error on fetching prypool products",
    },
    sharing_box: {
      checkout_session: "Something went wrong on Stripe, please try again.",
    },
    rental_session: {
      fetch: "Something went wrong on Stripe, please try again.",
    }
  },
  success: {
    commitment: {
      sign: "Your commitment was successfully registered.",
    },
    iam: {
      login: "You have logged in successfully",
      register: "Account created successfully, please check your email for the activation link",
    },
    update_user_details: {
      successfully_saved: "Your changes have successfully saved",
      successfully_changed_password: "Your password has successfully changed",
      recover_email_send: "You received an email with a reset password link",
      successfully_activated_account: "Your account has been activated",
      resend_activation_email: "Reactivation email successfully send",
    },
    save_circle: {
      successfully_saved: "Circle details successfully saved",
    },
    member_requests: {
      update: "Member request successfully updated",
      join_request: "Your request to join this circle has been sent.",
    },
    bookings: {
      add_booking: "Your booking has successfully registered",
      delete_booking: "Your booking has been deleted",
    },
    expenses: {
      add_expense: "Your expense has successfully registered",
      delete_expense: "Your expense has successfully deleted",
    },
    usage_logs: {
      add_usage: "Your usage log entry was successfully added",
      delete_usage_log: "Your usage log entry was successfully deleted",
    },
    circle_request: {
      send_request: "Your circle request was send.",
    },
    my_circles: {
      migrate: "Members successfully migrated",
    },
  },
  messages: {
    title: "No messages yet",
    description: "You need to be part of a co-owning circle in order to chat with other users.",
    write_first_message: "Write something to start the activity",
    create_circle: "Create your first circle",
    message_input_placeholder: "Start typing your message...",
  },
  admin_tabs: {
    log: "Usage logs",
    chat: "Chat",
    booking: "Booking",
    expenses: "Expenses",
    agreement: "Agreement",
  },
  agreement: {
    and: "and",
  },
  agreement_modal: {
    title: "Agreement",
  },
  or: "or",
  circle_form: { create_circle: "Co-owning circle" },
  cookie_banner: "This website uses cookies to enhance the user experience.",
  i_understand: "I understand",
  password_score: {
    too_short: "too short",
    weak: "weak",
    okay: "okay",
    good: "good",
    strong: "strong",
    stronger: "stronger",
  },
  custom_landing: {
    landing_automower: {
      buy_with_neighbours: "Buy with neighbours",
      learn_more: "Learn more",
      in_collaboration: "In collaboration with",
    },
    landing_othergardening: {
      buy_with_neighbours: "Buy with neighbours",
      sell_share: "Sell share of your tools",
      in_collaboration: "In collaboration with",
    },
    landing_existing_owner: {
      start_sharing: "Start using sharing tools",
      get_started: "Get started",
      post_boat_free: "Post your boat for free",
      sell_part_post_boat: "Post your boat for free",
      sell_part_get_started: "Get started",
      selling_points_header: "Why ihopa?",
      selling_points_safe_sharing: "Safe sharing",
      selling_points_safe_sharing_content: "Sharing agreement and insurance",
      selling_points_easy_sharing: "Easy sharing",
      selling_points_easy_sharing_content: "Booking calendar, expenses, logs...",
      selling_points_post_free: "Post your boat for free",
      selling_points_post_free_content: "And find suitable co-owners",
    },
    landing_buy_boat: {
      buy_boat: "Buy a boat with friends",
      buy_existing: "Buy into an existing boat",
    },
    landing_cool_stuff: {
      start_circle: "Start sharing circle",
      browse_circles: "Browse existing circles",
    },
  },
  whitemonday: {
    landing_whitemonday: {
      create_gift: "Create your gift",
      learn_more: "Learn more",
      not_sure: "Not sure yet?",
      people: "People",
    },
    puzzle_gift: {
      title: "Order puzzle gift card",
      header: "Order puzzle gift card",
      subheading: "We'll produce a puzzle with your picture. Totally free.",
      form_header: "Where should we send the puzzle?",
      form_p1:
        "Here you can order the fit card puzzle. it is designed to give every sharer one part of it as a giftcard. It is completely free to order:",
      form_p2_1: "- We will use your image or a similar illustration.",
      form_p2_2: "- We will send it to your address in around 5 business days.",
      form_p3:
        "During the christmas time we cannot guarantee delivery before christmas, if it gets close please use the free send-out option.",
      form_p4_1: "For any questions, please",
      form_p4_2: " contact us",
      send_order: "Send order",
    },
    placeholders: {
      address: "Your address",
      name: "Your full name",
    },
    errors: {
      send_puzzle_form: {
        name: "Please enter your name",
        location: "Please enter your address",
        send_request_error: "Error on requesting your puzzle, please try again.",
      },
    },
    success: {
      request_puzzle: {
        success: "Your request was send.",
      },
    },
    print_gift_card: {
      title: "Print gift card",
      header: "Print gift card",
      subheading: "Print a gift card that you can handover as present.",
      print_card: "Print Gift Card",
      give_part: "wants to give you a part of something he owns as a gift for #WhiteMonday.",
    },
  },
  b2b: {
    go_back: "Previous step",
    create_group: "Create co-owning Group",
    buy_with_friends: "Buy together",
    use_together: "Buy &amp; use together",
    mark_your_interest: "Mark your interest",
    share_your_group: "Share your group",
    select_owners_number: "Select the number of co-owners",
    co_owners: "Co-owners",
    per_owner: "Per owner",
    build_group: "Build your group",
    buy_together: "Buy it together",
    enjoy_together: "Enjoy together",
    non_binding: "Non-binding, No credit card required",
    setup_group: "Setup co-owning group",
    take_me_back: "Just take me back",
    invite_your_friends: "Invite your friends",
    match_with_people: "Or match with people nearby",
    sharing_agreement: "Sharing agreement",
    group_insurance: "Group insurance",
    booking_calendar: "Booking calendar",
    group_chat: "Group chat",
    expense_sharing: "Expense sharing",
    maintenance_logs: "Maintenance and other logs",
    what_kind_of_group: "What kind of co-owning group?",
    what_kind_of_group_note: "Note: Joining or opening a co-owning group is not binding before you sign the agreement.",
    start_friend_group: "Start a friend group",
    start_friend_group_copy: "Start a private group and invite your friends.",
    start_public_group: "Start a public group",
    start_public_group_copy: "Start a public group and find people near your location",
    send_invites: "Optional: Send invites to friends",
    share_group: "Share this group via your own channels",
    interested_not_ready: "Interested but not ready?",
    interested_not_ready_copy:
      "Just mark your interest and we will inform you if there are any new groups for this product near your current location.",
    members_no_helper: "%{members_no} Co-owners, ",
    change_members_no: " per person. Click to change",
    add_new_friend: "Add new friend",
    phone: "Phone",
    invalid_phone_number: "Invalid phone number",
    mark_interest_an_close: "Mark Interest &amp; Take Me Back",
    add_location: "Please add your location",
    share_step_copy: "Your group has been created and you can now share it with your friends or neighbours.",
  },
  no_image: "No image",
  minute: "Minute",
  hour: "Hour",
  day: "Day",
  week: "Week",
  minutes: "Minutes",
  hours: "Hours",
  days: "Days",
  weeks: "Weeks",
  prypool: {
    bundle_products: "Bundle products",
    unavailable_products: "Unavailable products",
    available_products: "Available products",
    checkout: "Checkout",
    thank_for_using: "Thank you for using our service and enjoy your items",
    back: "Back to products",
    transaction_successful: "Betalning lyckades och därmed vill vi varmt välkomna dig som medlem i ihopa Grannbox!",
    success_messages1:
      "Du har nu fått ett email från <a href='mailto:info@ihopa.com'>info@ihopa.com</a> med viktiga instruktioner samt länk till att välja lösenord så att du kan komma igång och boka produkterna. Om du inte hittar emailet, titta i din spam-folder och om det hamnat där, markera att det inte är spam så du får mail i fortsättningen.",
    success_messages2: "Stort tack.",
    price: "Price %{price}/month",
    price_month: "%{price}/month",
    address: "Address",
    get_access: "Get access now",
  },
  rental: {
    rental_price: "Rental price: ",
    transaction_successful: "You have successful rented this product. Please download the mobile app in order to access it.",
    rental: "Rental",
    download_on_app_store: "Download on App Store",
    download_on_google_play: "Download on Google Play"
  }
};

export default en;
